import { makeStyles } from '@mui/styles';
const GUTTER = 2;
const buttonWithIconStyles = makeStyles(({ palette }) => ({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: ({ iconSize, hideIcon }) => (hideIcon ? 20 : iconSize + 10),
        height: ({ iconSize }) => iconSize,
        position: 'relative',
        alignContent: 'center',
        display: 'flex',
        '&:hover span:last-child': {
            opacity: 0.96,
        },
    },
    icon: {
        display: ({ hideIcon }) => (hideIcon ? 'none' : 'block'),
        position: 'absolute',
        top: GUTTER,
        right: GUTTER,
        height: ({ iconSize }) => iconSize - GUTTER * 2,
        width: ({ iconSize }) => iconSize - GUTTER * 2,
        background: palette.primary.contrastText,
        borderRadius: '30px',
    },
}), { name: 'Common_ButtonWithIcon' });
export default buttonWithIconStyles;
//# sourceMappingURL=buttonWithIcon.styles.js.map